module.exports = __webpack_public_path__ + "media/assets/images/ajax-loader-c5cd7f5300576ab4c88202b42f6ded62.gif";